import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor() { }

  processParams(httpParams: HttpParams, params: any): HttpParams {
    if (!params) return httpParams;
    Object.keys(params).forEach((key) => {
      if (typeof undefined !== params[key] && params[key] !== null) httpParams = httpParams.append(key, params[key]);
    });
    return httpParams;
  }
}
